import React from "react";

type Props = {
  a: number | string;
  b: number | string;
};

export const DiffColorizer: React.FC<Props> = ({ a, b }) => {
  const s1 = String(a);
  const s2 = String(b);

  const maxLen = Math.max(s1.length, s2.length);

  let mismatchIndex: number | null = null;

  const chars = Array.from({ length: maxLen }, (_, i) => {
    const c1 = s1[i] ?? "";
    const c2 = s2[i] ?? "";

    if (mismatchIndex === null && c1 !== c2) {
      mismatchIndex = i;
    }

    let color = "#16C47F"; // green (matching)

    if (mismatchIndex !== null) {
      if (i === mismatchIndex) {
        color = "#f07e11"; // orange (first mismatch)
      } else if (i > mismatchIndex) {
        color = "#f07e11"; // red (after mismatch)
      }
    }

    return (
      <span
        key={i}
        style={{
          color,
          fontWeight: 800,
          fontFamily: "Raleway, Urbanist, sans-serif",
          fontSize: "14px",
        }}
      >
        {c1 || "∅"}
      </span>
    );
  });

  return <div style={{ fontFamily: "monospace" }}>{chars}</div>;
};
